'use client';

import { c as _c } from "react/compiler-runtime";
import { NavContainer, PrimaryNav } from '@petsmart-ui/sparky';
import { type MouseEvent, useEffect, useState } from 'react';
import { dataLayerPush, getBaseUrlJoined } from '@libs/analytics';
import { usePageLayout, useStore } from '@libs/common-next';
import { isUserLoggedIn } from '@libs/core';
import { handleServiceClick } from '@libs/experience-api';
import { propsMapper } from '../../utils/propsMapper';
import { LegacyMyStore } from '../LegacyMyStore/LegacyMyStore';
import { SubMenu } from './SubMenu';
import { type CategoryTypes, type MainMenuProps } from './types';
import { trackingData } from './utils';
import { handleNavLink } from './utils/handleNavLink';
import './MainMenu.scss';
import './MainMenuLayouts.scss';
import './MainMenuLegacy.scss';
import './MainMenuLegacyLayouts.scss';
export function MainMenu(t0) {
  const $ = _c(25);
  const {
    category: menuCategories
  } = t0;
  const {
    isAuthenticated,
    isSoftAuthenticated
  } = usePageLayout();
  const {
    selectedStore
  } = useStore();
  const {
    data: store
  } = selectedStore;
  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [menuTexts, setMenuTexts] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      container: "legacy-mainmenu__container",
      primaryNav: "legacy-mainmenu__primary-nav"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const navClasses = t2;
  let t3;
  if ($[2] !== menuCategories) {
    t3 = propsMapper(menuCategories).filter(_temp);
    $[2] = menuCategories;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const mappedCategories = t3;
  let t4;
  if ($[4] !== mappedCategories) {
    t4 = () => {
      const newMenuTexts = {};
      mappedCategories.forEach(mappedCategory => {
        const {
          sysId,
          type: t5,
          displayText
        } = mappedCategory;
        const type = t5 === undefined ? "text" : t5;
        const isMyStore = type === "my-store";
        newMenuTexts[sysId] = !isUserLoggedIn() && isMyStore ? "Find a Store" : displayText as string;
      });
      setMenuTexts(newMenuTexts);
    };
    $[4] = mappedCategories;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isAuthenticated || $[7] !== store) {
    t5 = [isAuthenticated, store];
    $[6] = isAuthenticated;
    $[7] = store;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t4, t5);
  const t6 = navClasses.container;
  const t7 = navClasses.primaryNav;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsSubMenuVisible(true);
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isAuthenticated || $[11] !== isSoftAuthenticated || $[12] !== isSubMenuVisible || $[13] !== mappedCategories || $[14] !== menuTexts || $[15] !== store) {
    let t10;
    if ($[17] !== isAuthenticated || $[18] !== isSoftAuthenticated || $[19] !== isSubMenuVisible || $[20] !== menuTexts || $[21] !== store) {
      t10 = mappedCategory_0 => {
        const {
          sysId: sysId_0,
          type: t11,
          displayText: displayText_0,
          link,
          specialType,
          categories,
          highlighted,
          menuDropdownStyle: t12
        } = mappedCategory_0;
        const type_0 = t11 === undefined ? "text" : t11;
        const menuDropdownStyle = t12 === undefined ? false : t12;
        const isMyStore_0 = type_0 === "my-store";
        const emptyStore = isMyStore_0 && !store;
        const currentText = menuTexts[sysId_0] || displayText_0;
        const {
          href,
          text
        } = handleNavLink(type_0, currentText, link, store);
        const handleOnClick = function handleOnClick(event) {
          dataLayerPush(trackingData({
            selection: displayText_0,
            link_url: getBaseUrlJoined(href)
          }));
          handleServiceClick({
            authType: isAuthenticated,
            event,
            link: href,
            isSoftAuthenticated
          });
        };
        return <PrimaryNav.Item tabIndex={-1} className={highlighted ? "highlighted" : ""} href={href} text={text} key={sysId_0} onNavItemClick={handleOnClick} id={displayText_0?.toLowerCase().split(" ").join("-")}>{!emptyStore && isSubMenuVisible && <>{(categories || type_0 === "card") && <SubMenu mappedCategory={mappedCategory_0} specialType={specialType} path={mappedCategory_0.displayText ? [mappedCategory_0.displayText] : []} type={type_0} parentCategory={displayText_0} menuDropdownStyle={menuDropdownStyle} />}{isMyStore_0 && <ul className="submenu-container__list"><LegacyMyStore /></ul>}</>}</PrimaryNav.Item>;
      };
      $[17] = isAuthenticated;
      $[18] = isSoftAuthenticated;
      $[19] = isSubMenuVisible;
      $[20] = menuTexts;
      $[21] = store;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    t9 = mappedCategories.map(t10);
    $[10] = isAuthenticated;
    $[11] = isSoftAuthenticated;
    $[12] = isSubMenuVisible;
    $[13] = mappedCategories;
    $[14] = menuTexts;
    $[15] = store;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <NavContainer data-testid="main-navigation" className={t6}><PrimaryNav className={t7} onMouseEnter={t8} id="primary-nav" data-testid="primary-nav">{t9}</PrimaryNav></NavContainer>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function _temp(c) {
  return c.sysId;
}